"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var defaultStyles = function (theme) {
    return {
        root: {},
        compact: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        message: styling_1.concatStyleSets(theme.fonts.medium, {
            backgroundColor: theme.palette.redDark,
            color: theme.palette.white,
            padding: "4px 8px"
        }),
        item: {
            margin: 8,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.palette.redDark
        },
        itemTitle: styling_1.concatStyleSets(theme.fonts.small, {
            backgroundColor: theme.palette.redDark,
            color: theme.palette.white,
            padding: "4px 8px"
        }),
        itemValue: styling_1.concatStyleSets(theme.fonts.small, {
            padding: 8,
            overflow: "auto"
        })
    };
};
exports.defaultStyles = defaultStyles;
var Defaults = {
    styles: defaultStyles
};
exports.Defaults = Defaults;
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    return styling_1.concatStyleSets(Defaults.styles(theme || styling_1.getTheme()), customStyles);
});
exports.getStyles = getStyles;
